import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <Section tone="cream" data-id="element-267" data-mp="3mg0pkwwhnbk5">
      <SectionTitle eyebrow="Social proof" data-id="element-268" data-mp="3meplsx31m3t1">
        Here's What Physicians Are Saying
      </SectionTitle>

      <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-269" data-mp="3r9byr4orw4f8">
        {testimonials.map(testimonial => <figure key={testimonial.name} className="flex flex-col rounded-3xl border border-navy/10 bg-white p-5" data-id="element-270" data-mp="3kcige49bxp">
            <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-271" data-mp="937ccxr769on">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-272" data-mp="dywdv6ms20nl" data-mpi={i} />)}
            </div>
            <blockquote className="mt-3 flex-1 text-[14.5px] leading-relaxed text-navy/80" data-id="element-273" data-mp="2fug8elgrkeiu">
              "{testimonial.quote}"
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3 border-t border-navy/10 pt-4" data-id="element-274" data-mp="1ntkhyvy1x79s">
              <img src={testimonial.photo} alt={testimonial.name} className="h-12 w-12 rounded-full object-cover" loading="lazy" data-id="element-275" data-mp="1ity90yp9ad6s" />
              <div data-id="element-276" data-mp="2bic87hs2zfjx">
                <p className="text-[14px] font-bold text-navy" data-id="element-277" data-mp="2bivfm4k3uljp">
                  {testimonial.name}
                </p>
                <p className="text-[12.5px] text-navy/55" data-id="element-278" data-mp="26i7rbqn9git6">{testimonial.role}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>

      <CTAButton className="mt-8" variant="navy" label="Join 2,000+ physicians today" subline="Instant access • $27 one-time" data-id="element-279" data-mp="1xiuc0hcgh00j" />
    </Section>;
}